import { roomEligibility } from "../../../../../api/src/shared/domain/room";
import type { CurrentUser } from "../../user/hooks/useCurrentUser";

type EligibilityRoom = Parameters<typeof roomEligibility>[0];

// The webapp only ever renders "may this user join" — the blocking criterion is
// consumed server-side by the JuisciGPT suppression report, never shown here
// (naming the restriction on a room the user cannot enter is the pattern the
// Rooms work deliberately avoids on the conversational surface).
export function isRoomEligible(
  room: EligibilityRoom,
  currentUser: CurrentUser | null
): boolean {
  if (currentUser === null) return false;
  return (
    roomEligibility(room, {
      country: currentUser.country,
      profession:
        currentUser.professionModel === null
          ? null
          : currentUser.professionModel.id,
      main_specialty:
        currentUser.mainSpecialtyModel === null
          ? null
          : currentUser.mainSpecialtyModel.id,
      medical_specialties: currentUser.medicalSpecialtyModels.map((m) => m.id),
    }).status === "eligible"
  );
}
